export default __webpack_public_path__ + "static/media/Maintenance.7062be5a.png";